/**
 * @desc 供应商列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierOrganizationalUnit.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierOrganizationalUnit/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
